import React from 'react';
import PropTypes from 'prop-types';
import { iconLoaders } from '@strava/icons/dynamic';

function lazy(name) {
  return React.lazy(iconLoaders[name]);
}

const activities = {
  alpineski: {
    small: lazy('sports_ski_normal_small'),
    xsmall: lazy('sports_ski_normal_xsmall')
  },
  backcountryski: {
    small: lazy('sports_ski_normal_small'),
    xsmall: lazy('sports_ski_normal_xsmall')
  },
  badminton: {
    small: lazy('sports_badminton_normal_small'),
    xsmall: lazy('sports_badminton_normal_xsmall')
  },
  basketball: {
    small: lazy('sports_basketball_normal_small'),
    xsmall: lazy('sports_basketball_normal_xsmall')
  },
  canoeing: {
    small: lazy('sports_kayaking_normal_small'),
    xsmall: lazy('sports_kayaking_normal_xsmall')
  },
  cricket: {
    small: lazy('sports_cricket_normal_small'),
    xsmall: lazy('sports_cricket_normal_xsmall')
  },
  crossfit: {
    small: lazy('sports_weight_training_normal_small'),
    xsmall: lazy('sports_weight_training_normal_xsmall')
  },
  dance: {
    small: lazy('sports_dance_normal_small'),
    xsmall: lazy('sports_dance_normal_xsmall')
  },
  ebikeride: {
    small: lazy('sports_e_bike_ride_normal_small'),
    xsmall: lazy('sports_e_bike_ride_normal_xsmall')
  },
  emountainbikeride: {
    small: lazy('sports_bike_e_mountain_normal_small'),
    xsmall: lazy('sports_bike_e_mountain_normal_xsmall')
  },
  elliptical: {
    small: lazy('sports_other_normal_small'),
    xsmall: lazy('sports_other_normal_xsmall')
  },
  golf: {
    small: lazy('sports_golf_normal_small'),
    xsmall: lazy('sports_golf_normal_xsmall')
  },
  gravelride: {
    small: lazy('sports_bike_gravel_normal_small'),
    xsmall: lazy('sports_bike_gravel_normal_xsmall')
  },
  highintensityintervaltraining: {
    small: lazy('sports_hiit_normal_small'),
    xsmall: lazy('sports_hiit_normal_xsmall')
  },
  handcycle: {
    small: lazy('sports_handcycle_normal_small'),
    xsmall: lazy('sports_handcycle_normal_xsmall')
  },
  hike: {
    small: lazy('sports_hike_normal_small'),
    xsmall: lazy('sports_hike_normal_xsmall')
  },
  hybridracing: {
    small: lazy('sports_hybrid_racing_normal_small'),
    xsmall: lazy('sports_hybrid_racing_normal_xsmall')
  },
  iceskate: {
    small: lazy('sports_ice_skate_normal_small'),
    xsmall: lazy('sports_ice_skate_normal_xsmall')
  },
  inlineskate: {
    small: lazy('sports_inline_skate_normal_small'),
    xsmall: lazy('sports_inline_skate_normal_xsmall')
  },
  kayaking: {
    small: lazy('sports_kayaking_normal_small'),
    xsmall: lazy('sports_kayaking_normal_xsmall')
  },
  kitesurf: {
    small: lazy('sports_kitesurf_normal_small'),
    xsmall: lazy('sports_kitesurf_normal_xsmall')
  },
  mountainbikeride: {
    small: lazy('sports_bike_mountain_normal_small'),
    xsmall: lazy('sports_bike_mountain_normal_xsmall')
  },
  nordicski: {
    small: lazy('sports_ski_normal_small'),
    xsmall: lazy('sports_ski_normal_xsmall')
  },
  padel: {
    small: lazy('sports_padel_normal_small'),
    xsmall: lazy('sports_padel_normal_xsmall')
  },
  pickleball: {
    small: lazy('sports_pickleball_normal_small'),
    xsmall: lazy('sports_pickleball_normal_xsmall')
  },
  pilates: {
    small: lazy('sports_pilates_normal_small'),
    xsmall: lazy('sports_pilates_normal_xsmall')
  },
  racquetball: {
    small: lazy('sports_racquetball_normal_small'),
    xsmall: lazy('sports_racquetball_normal_xsmall')
  },
  ride: {
    small: lazy('sports_bike_normal_small'),
    xsmall: lazy('sports_bike_normal_xsmall')
  },
  rockclimbing: {
    small: lazy('sports_rock_climbing_normal_small'),
    xsmall: lazy('sports_rock_climbing_normal_xsmall')
  },
  rollerski: {
    small: lazy('sports_ski_normal_small'),
    xsmall: lazy('sports_ski_normal_xsmall')
  },
  rowing: {
    small: lazy('sports_rowing_normal_small'),
    xsmall: lazy('sports_rowing_normal_xsmall')
  },
  run: {
    small: lazy('sports_run_normal_small'),
    xsmall: lazy('sports_run_normal_xsmall')
  },
  sail: {
    small: lazy('sports_windsurf_normal_small'),
    xsmall: lazy('sports_windsurf_normal_xsmall')
  },
  skateboard: {
    small: lazy('sports_skateboard_normal_small'),
    xsmall: lazy('sports_skateboard_normal_xsmall')
  },
  snowboard: {
    small: lazy('sports_snowboard_normal_small'),
    xsmall: lazy('sports_snowboard_normal_xsmall')
  },
  snowshoe: {
    small: lazy('sports_snowshoe_normal_small'),
    xsmall: lazy('sports_snowshoe_normal_xsmall')
  },
  soccer: {
    small: lazy('sports_soccer_normal_small'),
    xsmall: lazy('sports_soccer_normal_xsmall')
  },
  squash: {
    small: lazy('sports_squash_normal_small'),
    xsmall: lazy('sports_squash_normal_xsmall')
  },
  stairstepper: {
    small: lazy('sports_equipment_step_normal_small'),
    xsmall: lazy('sports_equipment_step_normal_xsmall')
  },
  standuppaddling: {
    small: lazy('sports_stand_up_paddling_normal_small'),
    xsmall: lazy('sports_stand_up_paddling_normal_xsmall')
  },
  surfing: {
    small: lazy('sports_surfing_normal_small'),
    xsmall: lazy('sports_surfing_normal_xsmall')
  },
  swim: {
    small: lazy('sports_water_normal_small'),
    xsmall: lazy('sports_water_normal_xsmall')
  },
  tabletennis: {
    small: lazy('sports_table_tennis_normal_small'),
    xsmall: lazy('sports_table_tennis_normal_xsmall')
  },
  tennis: {
    small: lazy('sports_tennis_normal_small'),
    xsmall: lazy('sports_tennis_normal_xsmall')
  },
  trailrun: {
    small: lazy('sports_run_trail_normal_small'),
    xsmall: lazy('sports_run_trail_normal_xsmall')
  },
  velomobile: {
    small: lazy('sports_velomobile_normal_small'),
    xsmall: lazy('sports_velomobile_normal_xsmall')
  },
  virtualride: {
    small: lazy('sports_bike_normal_small'),
    xsmall: lazy('sports_bike_normal_xsmall')
  },
  virtualrow: {
    small: lazy('sports_virtual_row_normal_small'),
    xsmall: lazy('sports_virtual_row_normal_xsmall')
  },
  virtualrun: {
    small: lazy('sports_run_normal_small'),
    xsmall: lazy('sports_run_normal_xsmall')
  },
  volleyball: {
    small: lazy('sports_volleyball_normal_small'),
    xsmall: lazy('sports_volleyball_normal_xsmall')
  },
  walk: {
    small: lazy('sports_walk_normal_small'),
    xsmall: lazy('sports_walk_normal_xsmall')
  },
  watersport: {
    small: lazy('sports_water_normal_small'),
    xsmall: lazy('sports_water_normal_xsmall')
  },
  weighttraining: {
    small: lazy('sports_weight_training_normal_small'),
    xsmall: lazy('sports_weight_training_normal_xsmall')
  },
  wheelchair: {
    small: lazy('sports_wheelchair_normal_small'),
    xsmall: lazy('sports_wheelchair_normal_xsmall')
  },
  windsurf: {
    small: lazy('sports_windsurf_normal_small'),
    xsmall: lazy('sports_windsurf_normal_xsmall')
  },
  wintersport: {
    small: lazy('sports_snow_normal_small'),
    xsmall: lazy('sports_snow_normal_xsmall')
  },
  workout: {
    small: lazy('sports_other_normal_small'),
    xsmall: lazy('sports_other_normal_xsmall')
  },
  yoga: {
    small: lazy('sports_yoga_normal_small'),
    xsmall: lazy('sports_yoga_normal_xsmall')
  }
};

const ActivityIcon = ({ type, size, ...props }) => {
  const sportTypeIcons = activities[type.toLowerCase()] || activities.workout;
  const SportTypeIcon = sportTypeIcons[size.toLowerCase()];

  if (SportTypeIcon) {
    return (
      <React.Suspense fallback={<div />}>
        {React.createElement(SportTypeIcon, { ...props })}
      </React.Suspense>
    );
  }

  return null;
};

ActivityIcon.propTypes = {
  type: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['xsmall', 'Xsmall', 'small', 'Small']).isRequired
};

export default ActivityIcon;
